<svelte:head>
	{#if instructor}
	<!-- Primary Meta Tags -->
  <title>D-NS Studio | {instructor.name}</title>
  <meta name="title" content="D-NS Studio | {instructor.name}">
  <meta name="description" content="{instructor.about || 'Todas nuestras clases sin salir de casa'}">
	<!-- FB Tags -->
	<meta property="og:url" content="https://d-ns.studio/instructores/{instructor.id}/">
	<meta property="og:title" content="D-NS Studio | {instructor.name}">
	<meta property="og:description" content="{instructor.about || 'Todas nuestras clases sin salir de casa'}">
	<meta property="og:image" content="{instructor.siteFeatured}">
	<!-- Twitter Tags -->
	<meta property="twitter:url" content="https://d-ns.studio/instructores/{instructor.id}/">
  <meta property="twitter:title" content="D-NS Studio | {instructor.name}">
  <meta property="twitter:description" content="{instructor.about || 'Todas nuestras clases sin salir de casa'}">
  <meta property="twitter:image" content="{instructor.siteFeatured}">
	{/if}
</svelte:head>

<style src="./style.scss">

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page instructor-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
		></MainMenu>
	</nav>
	{#if instructor}
	<section class="mbsc-row featured-image">
		<div class="mbsc-col-12">
			<FeaturedImage
				title={instructor.name}
				subtitle={instructor.subtitle}
				featured={instructor.siteFeatured}
			></FeaturedImage>
		</div>
		<div class="mbsc-col-12">
			<img src="{instructor.image}" class="mbsc-avatar" width="34" height="34" alt="rao">
			{#if instructor.social && instructor.social.fb}
			{#each instructor.social.fb as pages}
			<button 
				onclick="window.open('{pages.link}', '_blank');" 
				mbsc-button 
				class="mbsc-button mbsc-btn-flat mbsc-btn-dark facebook-btn">
					{pages.name}
			</button>
			{/each}
			{/if}
			{#if instructor.social && instructor.social.ig}
			{#each instructor.social.ig as pages}
			<button 
				onclick="window.open('{pages.link}', '_blank');" 
				mbsc-button 
				class="mbsc-button mbsc-btn-flat mbsc-btn-dark instagram-btn">
					{pages.name}
			</button>
			{/each}
			{/if}
		</div>
		<div class="mbsc-col-12 mbsc-col-md-6">
			<div class="mbsc-card">
				<div class="mbsc-card-header">
						<h2 class="mbsc-card-title">Acerca de {instructor.name}</h2>
						<h3 class="mbsc-card-subtitle">{instructor.subtitle}</h3>
				</div>
				<div class="mbsc-card-content">
						{@html instructor.about}
				</div>
				<div class="mbsc-card-footer mbsc-align-right">
					<button mbsc-button class="mbsc-button mbsc-btn-flat" on:click={() => Navigation.goTo('signup') }>
						Registrate ahora para acceder a todos los videos de {instructor.name}
					</button>
				</div>
			</div>
		</div>
	</section>
	{/if}
	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import MainMenu from '@Components/MainMenu/index.svelte';

import FeaturedImage from '@Components/FeaturedImage/index.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { Navigation, Utils, Instructor, AWSAnalytics } from '@Services';

const DEBUG = document.location.protocol === 'http:' ? true : false;
const instructors = Instructor.getAll();
let instructor = null;

export let router = null;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {
	document.body.dispatchEvent(new Event('mbsc-enhance')); 
});

onMount(async () =>{
	instructors.forEach(item => {
		if (router.params.name === item.id) {
			instructor = item;
		}
	});
	mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.card('.mbsc-card', {});

	mobiscroll.page('.instructor-page', {});

	Utils.scrollToTop();
});
</script>
